import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import LogItems from './components/LogItems';

interface Params {
    prepaidCardId: string;
}

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardLogActivity: Params;
    }
}

const PrepaidCardLogActivity: ActivityComponentType<'PrepaidCardLogActivity'> = ({ params }) => {
    const { prepaidCardId } = params;
    const { t } = useTranslation('prepaidCard');
    return (
        <AppScreen>
            <Header title={t('log.title')} />
            <LogItems id={prepaidCardId}/>
        </AppScreen>
    );
};

export default PrepaidCardLogActivity;
